import React from "react";
import Link from "next/link";
const AreaQualifierAreaCards = ({
  areas
}) => {
  return <>
			{areas?.map(item => {
      return <Link href={`/loretta-lynn-tracker/area-qualifiers/region/${encodeURIComponent(item.region)}`} key={item.region} className="dark:bg-jacarta-700 dark:border-jacarta-700 border-jacarta-100 rounded-2.5xl relative flex items-center border bg-white p-8 transition-shadow hover:shadow-lg mb-6" prefetch={false}>
					<div>
						<h3 className="font-display text-jacarta-700 mb-1 text-base font-semibold dark:text-white">
							{item.region}
						</h3>
						<span className="dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm">
							{item.qualifiers} qualifiers
						</span>
					</div>
					<div className="dark:border-jacarta-600 border-jacarta-100 ml-auto rounded-full border p-3">
						<svg className="icon fill-jacarta-700 dark:fill-white h-6 w-6">
							<use xlinkHref={`/icons.svg#icon-proparties-icon`}></use>
						</svg>
					</div>
				</Link>;
    })}
		</>;
};
export default AreaQualifierAreaCards;